'use strict';

angular.module('HRRoutes', ['HRControllers',
                            'services.authenticatedUser',
                            'HRConfirmationsRoutes'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('HR', {
            url: '/HR',
            controller: 'HRController',
            template: '<div ui-view></div>',
            resolve: {
                authenticatedUser: ['authenticatedUserService', function (service) {
                    return service.getAuthenticatedUser();
                }],
            }
        })
  //      .state('HR.history', {
  //          url: '/History',
  //          templateUrl: require('./HR.tpl.html'),
  //          controller: 'HRController',
		//})
		;
}]);